import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { AppState } from './app.reducer';
import { combineLatest, filter, map, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromState from './store/state.actions';
import { OrganizationsService } from './services/organizations.service';
import { DeliveryAddress } from './models/address';
import { APP_ORGANIZATION_CODE } from 'app/common';

@Injectable({
  providedIn: 'root'
})
export class StateResolverService implements Resolve<DeliveryAddress | null> {

  constructor(
    private store: Store<AppState>,
    private organizationsService: OrganizationsService,
    @Inject(APP_ORGANIZATION_CODE) private organizationCode: string
  ) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<DeliveryAddress | null> {
    return combineLatest([
      this.store.select('organizationInfo')
    ]).pipe(
      filter(([organizationInfo]) => !organizationInfo.isLoading),
      take(1),
      switchMap(() => {
        return this.organizationsService.getStoredState(this.organizationCode)
          .pipe(
            take(1),
            map(stateState => {
              this.store.dispatch(fromState.setCurrentAddressAction({
                organizationCode: this.organizationCode,
                deliveryAddress: stateState.currentAddress,
                deliveryZone: stateState.currentZone
              }));
              return stateState.currentAddress;
            })
          );
      })
    );
  }
}
